// API配置文件 - 简化版

export default {
  // 设备数据相关API
  devices: {
    // getDeviceData: (deviceId) => `/api/getEquipmentData?deviceId=${deviceId}`,
    // getAllDevices: () => '/api/getEquipmentData',
    getAllGroups: () => '/api/wsd/get_temperature_humidity_groups',
    getMultiDeviceHistoryData: () => '/api/wsd/get_multi_device_history_data'
  },

  // 系统相关API
  system: {
    status: () => '/api/status'
  }
};